<div class="col-md-12" style="margin-left: -125px">
    <div class="tab-pane" role="tabpanel" id="formulario23">
        <fieldset id="agregar_formulario23" class="">
            <div class="container" id="center_div">
                <div class="row">
                    <div class="col-md-12">
                        <div id='page1' class="contenedorFormulario print-wrap page1">
                            <div>
                                <span style="float: right; clear: right;">(S.P.E.- 5.1.4/5.1.6)</span> Formulario 2.3
                                <span style="float: right; clear: right;">1/5</span>
                            </div>
                            <h1><strong>SOLICITUD DE PERMISO DE EDIFICACI&Oacute;N</strong></h1>
                            <br />
                            <div class="col-md-1"></div>
                            <div class="col-md-10">
                                <table class="title">
                                    <tr>

                                        <td class="col-md-3">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].obra" name="obra" id="obra" />
                                            <label class="titleBox" for="optradio"> OBRA NUEVA</label>
                                        </td>
                                        <td class="col-md-4 letraChica">
                                            <label class="titleBox" for="optradio">LOTEO DFL CON INSTRUCCION SIMULTANEA</label>
                                        </td>
                                        <td class="col-md-1 letraChica">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].loteo_dfl == 'SI'" name="loteo_dfl" id="loteo_dfl" />
                                            <label class="titleBox" for="loteo_dfl"> SI</label>
                                        </td>
                                        <td class="col-md-1 letraChica">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].loteo_dfl == 'NO'" name="loteo_dfl" id="loteo_dfl" />
                                            <label class="titleBox" for="loteo_dfl"> NO</label>
                                        </td>
                                        <td class="col-md-3">&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                    </tr>
                                    <tr>
                                        <td class="col-md-3"></td>
                                        <td class="col-md-4 letraChica">
                                            <label class="titleBox" for="optradio">LOTEO DFL CON CONSTRUCCION SIMULTANEA</label>
                                        </td>
                                        <td class="col-md-1 letraChica">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].loteo_const == 'SI'" name="loteo_const" id="loteo_const" />
                                            <label class="titleBox" for="loteo_const"> SI</label>
                                        </td>
                                        <td class="col-md-1 letraChica">
                                            <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].loteo_const == 'NO'" name="loteo_const" id="loteo_const" />
                                            <label class="titleBox" for="loteo_const"> NO</label>
                                        </td>
                                        <td class="col-md-3">&nbsp;&nbsp;&nbsp;&nbsp;</td>
                                    </tr>
                                </table>
                            </div>
                            <div class="col-md-1"></div>
                            <table>
                                <tr>
                                    <td class="col-md-3">
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].ampliacion" name="optradio2" id="optradio" />
                                        <label class="titleBox" for="optradio"> AMPLIACI&Oacute;N MAYOR A 100 M2</label>
                                    </td>
                                    <td class="col-md-3">
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].alteracion" name="optradio3" id="optradio" />
                                        <label class="titleBox" for="optradio"> ALTERACI&Oacute;N</label>
                                    </td>
                                    <td class="col-md-3">
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].reparacion" name="optradio1" id="optradio" />
                                        <label class="titleBox" for="optradio"> REPARACION</label>
                                    </td>
                                    <td class="col-md-3">
                                        <input disabled class="form-check-inline encab" type="checkbox" [checked]="tipo_permiso[0].reconstruccion" name="optradio3" id="optradio" />
                                        <label class="titleBox" for="optradio"> RECONSTRUCCI&Oacute;N</label>
                                    </td>
                                </tr>
                            </table>
                            <br />
                            <div class="row">
                                <div class="col-md-4">
                                    &nbsp;
                                </div>
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                    <table class="tablaConBorde">
                                        <tr>
                                            <td>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'urbano'" [checked]="propiedad[0].ubicacion == 'URBANO'" />
                                                <label for="tpradio">URBANO</label>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span><span>&nbsp;</span>
                                                <input disabled class="urb" type="checkbox" name="tpradio" id="tpradio" [checked]="propiedad[0].ubicacion == 'rural'" [checked]="propiedad[0].ubicacion == 'RURAL'" />
                                                <label for="tpradio">RURAL</label>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 140px;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>
                                        <tfoot>
                                            <tr>
                                                <td class="letraChica">
                                                    * A LLENAR POR LA D.O.M
                                                </td>
                                            </tr>
                                        </tfoot>
                                    </table>
                                </div>
                            </div>
                            <br />
                            <div>
                                <table style="width: 100%;" class="tablaConBorde table">

                                    <tr class="rd_tipo">
                                        <td class="fondoResaltado izquierda" rowspan="2" style="width: 40%">
                                            CERTIFICADO DE INFORMACIONES PREVIAS:

                                        </td>
                                        <td class="fondoResaltado">
                                            N&uacute;mero
                                        </td>
                                        <td class="fondoResaltado">
                                            Fecha
                                        </td>

                                    </tr>
                                    <tr class="rd_tipo">
                                        <td>
                                            <input disabled class="form-control" type="text" name="certcip" id="certcip" [(ngModel)]="cip[0].certcip" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" type="text" name="fecha_cip" id="fecha_cip" [(ngModel)]="cip[0].fecha_cip" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span> 1.- DIRECCI&Oacute;N DE LA PROPIEDAD</span>
                                    <span class="help-block"></span>
                                </div>
                                <table style="width: 100%" border="0" class="tablaConBorde table">
                                    <tr class="fondoResaltado">
                                        <td style="width: 57%" colspan="3">
                                            CALLE O CAMINO
                                        </td>
                                        <td style="width: 24%">
                                            N&Uacute;MERO
                                        </td>
                                        <td style="width: 19%">
                                            ROL SII
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propiedad[0].calle" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propiedad[0].calle_num" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" />
                                        </td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td style="width: 11%">
                                            MANZANA
                                        </td>
                                        <td style="width: 10%">
                                            LOTE
                                        </td>
                                        <td style="width: 61%" colspan="2">
                                            LOTEO O LOCALIDAD
                                        </td>
                                        <td style="width: 18%">
                                            PLANO DE LOTEO N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="manzana" name="manzana" type="text" [(ngModel)]="propiedad[0].manzana" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" name="lote" id="lote" type="text" [(ngModel)]="propiedad[0].lote" />
                                        </td>
                                        <td colspan="2">
                                            <input disabled class="form-control" id="localidad" name="localidad" type="text" [(ngModel)]="propiedad[0].localidad" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="loteo_numero" name="loteo_numero" type="text" [(ngModel)]="propiedad[0].loteo_numero" />
                                        </td>
                                    </tr>
                                </table>

                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>2.- DECLARACION JURADA</span>
                                    <span class="help-block"></span>
                                </div>

                                <table style="width: 100%;" class="tablaConBordeExterno table">
                                    <tr>
                                        <td colspan="7"><input disabled class="form-control" id="nombre" name="nombre" type="text" [(ngModel)]="propietarios[0].nombre" /></td>
                                        <td align="right" colspan="4"><span>C&Eacute;DULA DE</span></td>

                                    </tr>
                                    <tr>
                                        <td align="left"><span>IDENTIDAD Nº</span></td>
                                        <td colspan="5"><input disabled class="form-control" id="rut" name="rut" type="text" [(ngModel)]="propietarios[0].rut" /></td>
                                        <td colspan="5" align="right"><span>DECLARA BAJO SU RESPONSABILIDAD</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span> SER</span></td>
                                        <td align="left"><span>PROPIETARIO</span></td>
                                        <td colspan="3" align="center"><span>(O  REPRESENTANTE  LEGAL  DEL  PROPIETARIO)</span> </td>
                                        <td colspan="2"><span>DEL  BIEN  RAIZ</span></td>
                                        <td align="left" colspan="4"><span>UBICADO  EN  CALLE/ </span></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>/AVENIDA/CAMINO</span></td>
                                        <td align="right" colspan="3"><input disabled class="form-control" id="calle" name="calle" type="text" [(ngModel)]="propietarios[0].direccion" /></td>
                                        <td align="left" colspan="3"><span>NUMERO:</span> </td>
                                        <td align="left" colspan="4"><input disabled class="form-control" id="numero" name="numero" type="text" [(ngModel)]="propietarios[0].direccion_num" /></td>
                                    </tr>
                                    <tr>
                                        <td align="left"><span>ROL DE AVALUO Nº</span></td>
                                        <td align="right" colspan="2"><input disabled class="form-control" id="rol" name="rol" type="text" [(ngModel)]="propiedad[0].rol" /></td>
                                        <td align="left"> <span>DE LA COMUNA DE </span></td>
                                        <td align="right" colspan="7"><input disabled class="form-control" id="comuna" name="comuna" [(ngModel)]="propietarios[0].comuna" type="text" /></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" align="left"><span>QUE SE ENCUENTRA INSCRITO A FOJAS</span></td>
                                        <td align="right"><input disabled class="form-control" id="inscripcion" name="inscripcion" type="text" [(ngModel)]="registro_bienes[0].inscrito" /></td>
                                        <td align="center"><span>N°</span></td>
                                        <td align="right" colspan="2"><input disabled class="form-control" id="num_insc" name="num_insc" type="text" [(ngModel)]="registro_bienes[0].numero" /></td>
                                        <td align="center"><span>AÑO</span></td>
                                        <td align="right"><input disabled class="form-control" id="anio_insc" name="anio_insc" type="text" [(ngModel)]="registro_bienes[0].anio" /></td>
                                        <td colspan="3" align="left"><span>DEL REGISTRO</span></td>
                                    </tr>
                                    <tr>
                                        <td align="left">DE PROPIEDAD</td>
                                        <td colspan="2" align="left"> DEL CONSERVADOR</td>
                                        <td align="left"> DE BIENES </td>
                                        <td align="left"> RAÍCES DE</td>
                                        <td align="left" colspan="6"><input disabled class="form-control" id="bienes" name="bienes" type="text" [(ngModel)]="registro_bienes[0].bienes" /></td>

                                    </tr>
                                    <tr>
                                        <td align="left">EN EL CUAL</td>
                                        <td align="left">SE EMPLAZA</td>
                                        <td colspan="2" align="left"><span>EL PROYECTO</span></td>
                                        <td align="left"><span>PARA EL QUE SE</span></td>
                                        <td colspan="6" align="left"><span>PRESENTA ESTA SOLICITUD</span></td>

                                    </tr>

                                </table>
                                <table class="tablaConBorde table">
                                    <tr>
                                        <td colspan="2" class="fondoResaltado izquierda" style="width: 40%;" align="left"><span>ADJUNTA PLANO TOPOGRAFICO (*)</span><span class="letraChica"> ART 1.4.8 OGUC</span></td>
                                        <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'SI'"/>SI</span></td>
                                        <td style="width: 5%; " align="center"><span><input disabled class="form-check-inline" type="checkbox" name="plano" id="plano"  [checked]="declaracion[0].plano == 'NO'"/>NO</span></td>
                                        <td colspan="2" class="fondoResaltado" style="width: 50%; " align="left"><span></span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 20%; " align="left" class="fondoResaltado izquierda"><span>DENOMINADO: </span></td>
                                        <td colspan="5"><span><input disabled class="form-control" id="denominado" name="denominado" type="text" [(ngModel)]="declaracion[0].denominado"/></span></td>

                                    </tr>
                                    <tr>
                                        <td style="width: 20%; " align="left" class="fondoResaltado izquierda"><span>ELABORADO</span></td>
                                        <td colspan="3"><span><input disabled class="form-control" id="elaborado" name="elaborado" type="text" [(ngModel)]="declaracion[0].elaborado"/></span></td>
                                        <td style="width: 20%; " align="left" class="fondoResaltado izquierda"><span>DE PROFESION</span></td>
                                        <td><span><input disabled class="form-control" id="profesion" name="profesion" type="text" [(ngModel)]="declaracion[0].profesion" /></span></td>
                                    </tr>
                                </table>

                                <div class="letraChica"><span>NOTA: DE EXISTIR DOS O MÁS PROPIETARIOS, Y/O DOS O MÁS BIENES RAÍCES SE DEBERÁ ACOMPAÑAR HOJA ADJUNTA CON LOS DATOS Y FIRMAS CORRESPONDIENTE (*) SOLO EN LA EVENTUALIDAD QUE SE ACOMPAÑE DICHO PLANO.</span></div>

                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span>3.- DATOS DEL PROPIETARIO</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%">
                                            NOMBRE DEL PROPIETARIO
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                        <td>
                                            FIRMA DEL PROPIETARIO
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="nombre_prop" name="nombre_prop" type="text" [(ngModel)]="propietarios[0].nombre" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="rut_prop" name="rut_prop" type="text" [(ngModel)]="propietarios[0].rut" />
                                        </td>
                                        <td rowspan="7">

                                        </td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%">
                                            REPRESENTANTE LEGAL
                                        </td>
                                        <td>
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2"><input disabled class="form-control" readonly id="nombre_rep" name="nombre_rep" type="text" [(ngModel)]="representantes[0].nombre" /></td>
                                        <td><input disabled class="form-control" id="rut_rep" name="rut_rep" type="text" [(ngModel)]="representantes[0].rut" /></td>
                                    </tr>

                                    <tr class="fondoResaltado">
                                        <td style="width: 25%">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 25%">
                                            N°
                                        </td>
                                        <td style="width: 25%">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="propietarios[0].direccion" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="propietarios[0].direccion_num" />
                                        </td>
                                        <td style="width: 25%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="propietarios[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td>
                                            E-MAIL
                                        </td>
                                        <td>
                                            TEL&Eacute;FONO
                                        </td>
                                        <td>
                                            FAX
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_prop" name="email_prop" type="email" [(ngModel)]="propietarios[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_prop" name="tel_prop" type="text" [(ngModel)]="propietarios[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_prop" name="fax_prop" type="text" [(ngModel)]="propietarios[0].fax" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado tablaConBordeExterno table">
                                        <td colspan="4">
                                            PERSONERIA DEL REPRESENTANTE LEGAL
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            SE ACREDITA MEDIANTE
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="acredita" name="acredita" type="text" [(ngModel)]="permiso_notariado[0].acreditacion" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            DE FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_acr" name="fecha_acr" type="text" [(ngModel)]="permiso_notariado[0].fecha" />
                                        </td>
                                        <td>
                                            Y REDUCIDA A ESCRITURA PUBLICA CON FECHA
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fecha_esc" name="fecha_esc" type="text" [(ngModel)]="permiso_notariado[0].escritura" />
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            ANTE EL NOTARIO SR(A)
                                        </td>
                                        <td colspan="3">
                                            <input disabled class="form-control" id="notario" name="notario" type="text" [(ngModel)]="permiso_notariado[0].notario" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                            <br />
                        </div>
                        <div id='page2' class="contenedorFormulario print-wrap page2">
                            <div>
                                <span style="float: right; clear: right;">(S.R.E.A - 5.1.4)</span> Formulario 2.3
                                <span style="float: right; clear: right;">2/5</span>
                            </div>
                            <br />
                            <div>
                                <div class="tituloSeccion">
                                    <span>4.- ARQUITECTO PROYECTISTA</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group clone1">
                                    <tr class="fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left"><span>
                                                NOMBRE O RAZON SOCIAL DE LA EMPRESA</span><span class="letraChica">(cuando corresponda)</span>
                                        </td>
                                        <td style="width: 20%">
                                            R.U.T.
                                        </td>
                                        <td style="width: 15%">
                                            FIRMA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 65%">
                                            <input disabled class="form-control" readonly id="nombre_emp" name="nombre_emp" type="text" [(ngModel)]="empresas[0].nombre" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="rut_emp" name="rut_emp" type="text" [(ngModel)]="empresas[0].rut" />
                                        </td>
                                        <td rowspan="5" style="width: 15%"></td>

                                    </tr>
                                    <tr class=" fondoResaltado">
                                        <td colspan="2" style="width: 65%" align="left">
                                            NOMBRE ARQUITECTO PROYECTISTA
                                        </td>
                                        <td style="width: 20%">
                                            R.U.T.
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 60%"><input disabled class="form-control" readonly id="nombre_arq" name="nombre_arq" type="text" [(ngModel)]="arquitectos[0].nombre" /></td>
                                        <td style="width: 20%"><input disabled class="form-control" id="rut_arq" name="rut_arq" type="text" [(ngModel)]="arquitectos[0].rut" /></td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda" style="width: 30%">
                                            DIRECCI&Oacute;N / CALLE / PASAJE
                                        </td>
                                        <td style="width: 30%" class="fondoResaltado">
                                            N°
                                        </td>
                                        <td style="width: 20%" class="fondoResaltado">
                                            COMUNA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td style="width: 30%">
                                            <input disabled class="form-control" id="direccion" name="direccion" type="text" [(ngModel)]="arquitectos[0].direccion" />
                                        </td>
                                        <td style="width: 30%">
                                            <input disabled class="form-control" id="num" name="num" type="text" [(ngModel)]="arquitectos[0].direccion_num" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="comuna" name="comuna" type="text" [(ngModel)]="arquitectos[0].comuna" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda" style="width: 30%">
                                            E-MAIL
                                        </td>
                                        <td class="fondoResaltado" style="width: 30%">
                                            TEL&Eacute;FONO
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            FAX
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            PATENTE PROFESIONAL N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_arq" name="email_arq" type="email" [(ngModel)]="arquitectos[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_arq" name="tel_arq" type="text" [(ngModel)]="arquitectos[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_arq" name="fax_arq" type="text" [(ngModel)]="arquitectos[0].fax" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="pat_arq" name="pat_arq" type="text" [(ngModel)]="arquitectos[0].patente" />
                                        </td>
                                    </tr>
                                </table>
                                <br />
                                <table class="tablaConBorde table form-group clone1">
                                    <tr>
                                        <td colspan="2" class="fondoResaltado izquierda" style="width: 60%"><span>
                                                CALCULISTA </span><span class="letraChica"> (NOMBRE) </span>
                                        </td>
                                        <td style="width: 20%" class="fondoResaltado">
                                            R.U.T.
                                        </td>
                                        <td style="width: 20%" class="fondoResaltado">
                                            FIRMA CALCULISTA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 60%">
                                            <input disabled class="form-control" readonly id="nombre_calc" name="nombre_calc" type="text" [(ngModel)]="calculistas[0].nombre" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="rut_calc" name="rut_calc" type="text" [(ngModel)]="calculistas[0].rut" />
                                        </td>
                                        <td rowspan="5" style="width: 20%"></td>

                                    </tr>
                                    <tr>
                                        <td colspan="2" class="fondoResaltado izquierda" style="width: 60%">
                                            DOMICILIO
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            PATENTE PROF N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 60%"><input disabled class="form-control" readonly id="direccion" name="direccion" type="text" [(ngModel)]="calculistas[0].direccion_completa" /></td>
                                        <td style="width: 20%"><input disabled class="form-control" id="rut_arq" name="rut_arq" type="text" [(ngModel)]="calculistas[0].patente" /></td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda" style="width: 30%">
                                            E-MAIL
                                        </td>
                                        <td class="fondoResaltado" style="width: 30%">
                                            TEL&Eacute;FONO
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            FAX
                                        </td>

                                    </tr>
                                    <tr>
                                        <td>
                                            <input disabled class="form-control" id="email_calc" name="email_calc" type="email" [(ngModel)]="calculistas[0].mail" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="tel_calc" name="tel_calc" type="text" [(ngModel)]="calculistas[0].fono" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" id="fax_calc" name="fax_calc" type="text" [(ngModel)]="calculistas[0].fax" />
                                        </td>

                                    </tr>
                                </table>
                                <br />
                                <table class="tablaConBorde table form-group clone1">
                                    <tr>
                                        <td colspan="2" style="width: 60%" class="fondoResaltado izquierda"><span>
                                                    CONSTRUCTOR </span><span class="letraChica"> (NOMBRE) </span><span>(*)</span>
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            R.U.T.
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            FIRMA CONSTRUCTOR
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 60%">
                                            <input disabled class="form-control" readonly id="nombre_const" name="nombre_const" type="text" [(ngModel)]="constructores[0].nombre" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="rut_const" name="rut_const" type="text" [(ngModel)]="constructores[0].rut" />
                                        </td>
                                        <td rowspan="5" style="width: 20%"></td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda" colspan="2" style="width: 60%">
                                            DOMICILIO
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            PATENTE PROF N°
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 60%"><input disabled class="form-control" readonly id="direccion" name="direccion" type="text" [(ngModel)]="constructores[0].direccion_completa" /></td>
                                        <td style="width: 20%"><input disabled class="form-control" id="rut_const" name="rut_const" type="text" [(ngModel)]="constructores[0].patente" /></td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda" style="width: 30%">
                                            E-MAIL
                                        </td>
                                        <td class="fondoResaltado" style="width: 30%">
                                            TEL&Eacute;FONO
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            FAX
                                        </td>

                                    </tr>
                                    <tr>
                                        <td style="width: 30%">
                                            <input disabled class="form-control" id="email_calc" name="email_calc" type="email" [(ngModel)]="constructores[0].mail" />
                                        </td>
                                        <td style="width: 30%">
                                            <input disabled class="form-control" id="tel_calc" name="tel_calc" type="text" [(ngModel)]="constructores[0].fono" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="fax_calc" name="fax_calc" type="text" [(ngModel)]="constructores[0].fax" />
                                        </td>
                                    </tr>
                                </table>
                                <div><span class="letraChica">(*) Profesional que pordr&aacute; individualizarse hasta antes del inicio de las obras</span></div>
                            </div>
                            <br />
                            <div>
                                <div class="tituloSeccion">
                                    <span>5.- PARTICIPACION DE REVISORES</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td style="width: 50%" class="fondoResaltado izquierda"><span>
                                               CUENTA CON INFORME FAVORABLE REVISOR INDEPENDIENTE</span>
                                        </td>
                                        <td style="width: 5%" align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="informe" name="informe" value="SI" [checked]="informe[0].infradio == 'SI'" /><span>SI</span></td>
                                        <td style="width: 5%" align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="informe" name="informe" value="NO" [checked]="informe[0].infradio == 'NO'" /><span>NO</span></td>
                                        <td style="width: 7%" class="fondoResaltado"><span>N°</span></td>
                                        <td style="width: 10%"><span><input disabled class="form-control" readonly id="numero" name="numero" type="text" [(ngModel)]="informe[0].num_informe"/></span></td>
                                        <td style="width: 9%" class="fondoResaltado"><span>Fecha</span></td>
                                        <td style="width: 10%"><span><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" [(ngModel)]="informe[0].fech_informe"/></span></td>
                                    </tr>
                                </table>
                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td class="fondoResaltado izquierda" colspan="2" style="width: 60%">
                                            NOMBRE DEL REVISOR INDEPENDIENTE
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            R.U.T.
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            FIRMA REVISOR
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 60%">
                                            <input disabled class="form-control" readonly id="nombre_ind" name="nombre_ind" type="text" [(ngModel)]="independiente[0].nombre" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="rut_ind" name="rut_ind" type="text" [(ngModel)]="independiente[0].rut" />
                                        </td>
                                        <td rowspan="3" style="width: 20%"></td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="fondoResaltado izquierda" style="width: 80%">
                                            DOMICILIO
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" style="width: 80%"><input disabled class="form-control" readonly id="direccion" name="direccion" type="text" [(ngModel)]="independiente[0].direccion_completa" /></td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td style="width: 30%">EMAIL</td>
                                        <td style="width: 30%">TELEFONO / FAX</td>
                                        <td style="width: 20%">REGISTRO</td>
                                        <td style="width: 20%">CATEGORIA</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 30%"><input disabled class="form-control" readonly id="email_ind" name="email_ind" type="text" [(ngModel)]="independiente[0].mail" /></td>
                                        <td style="width: 30%"><input disabled class="form-control" readonly id="telf_ind" name="telf_ind" type="text" [(ngModel)]="independiente[0].fono" /></td>
                                        <td style="width: 20%"><input disabled class="form-control" readonly id="cat_ind" name="cat_ind" type="text" [(ngModel)]="independiente[0].categoria" /></td>
                                        <td style="width: 20%"><input disabled class="form-control" readonly id="reg_ind" name="reg_ind" type="text" [(ngModel)]="independiente[0].registro" /></td>
                                    </tr>
                                </table>
                                <br />
                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td style="width: 50%" class="fondoResaltado izquierda"><span>
                                                   CUENTA CON INFORME DE REVISOR DE CALCULO ESTRUCTURAL</span>
                                        </td>
                                        <td style="width: 5%" align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="informe" name="informe" value="SI" [checked]="informe_revisor[0].infradio == 'SI'" /><span>SI</span></td>
                                        <td style="width: 5%" align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="informe" name="informe" value="NO" [checked]="informe_revisor[0].infradio == 'NO'" /><span>NO</span></td>
                                        <td style="width: 7%" class="fondoResaltado"><span>N°</span></td>
                                        <td style="width: 10%"><span><input disabled class="form-control" readonly id="numero" name="numero" type="text" [(ngModel)]="informe_revisor[0].num_informe"/></span></td>
                                        <td style="width: 9%" class="fondoResaltado"><span>Fecha</span></td>
                                        <td style="width: 10%"><span><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" [(ngModel)]="informe_revisor[0].fecha_informe"/></span></td>
                                    </tr>
                                </table>
                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td colspan="2" class="fondoResaltado izquierda" style="width: 60%">
                                            NOMBRE O RAZON SOCIAL DEL REVISOR DE CALCULO
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            R.U.T.
                                        </td>
                                        <td class="fondoResaltado" style="width: 20%">
                                            FIRMA REVISOR
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 60%">
                                            <input disabled class="form-control" readonly id="nombre_ind" name="nombre_ind" type="text" [(ngModel)]="revisor[0].nombre" />
                                        </td>
                                        <td style="width: 20%">
                                            <input disabled class="form-control" id="rut_ind" name="rut_ind" type="text" [(ngModel)]="revisor[0].rut" />
                                        </td>
                                        <td rowspan="7" style="width: 20%"></td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" class="fondoResaltado izquierda" style="width: 60%">
                                            NOMBRE PROFESIONAL COMPETENTE
                                        </td>
                                        <td class="fondoResaltado " style="width: 20%">
                                            CATEGORIA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="2" style="width: 40%"><input disabled class="form-control" readonly id="nombre_rev" name="nombre_rev" type="text" [(ngModel)]="revisor[0].nombre" /></td>
                                        <td style="width: 20%"><input disabled class="form-control" readonly id="cat_rev" name="cat_rev" type="text" [(ngModel)]="revisor[0].categoria" /></td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" class="fondoResaltado izquierda" style="width: 60%">
                                            DOMICILIO
                                        </td>
                                    </tr>
                                    <tr>
                                        <td colspan="3" style="width: 60%"><input disabled class="form-control" readonly id="direccion" name="direccion" type="text" [(ngModel)]="revisor[0].direccion_completa" /></td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td style="width: 40%">EMAIL</td>
                                        <td style="width: 20%">TELEFONO / FAX</td>
                                        <td style="width: 20%">REGISTRO</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 40%"><input disabled class="form-control" readonly id="email_ind" name="email_ind" type="text" [(ngModel)]="revisor[0].mail" /></td>
                                        <td style="width: 20%"><input disabled class="form-control" readonly id="telf_ind" name="telf_ind" type="text" [(ngModel)]="revisor[0].fono" /></td>
                                        <td style="width: 20%"><input disabled class="form-control" readonly id="cat_ind" name="cat_ind" type="text" [(ngModel)]="revisor[0].registro" /></td>
                                    </tr>
                                </table>
                                <br />
                                <div class="tituloSeccion">
                                    <span>6.- CARACTERISTICAS DEL PROYECTO</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td class="fondoResaltado izquierda" style="width:  70%">
                                            EDIFICIOS DE USO PUBLICO
                                        </td>
                                        <td align="center" style="background: white; width: 12%">
                                            <span><input type="checkbox" disabled class="form-check-inline" readonly id="" name="uso_publico" value="SI" [checked]="caract_anteproyecto[0].uso_publico == 'todo'" /> TODO</span>
                                        </td>
                                        <td align="center" style="background: white; width: 12%">
                                            <span><input type="checkbox" disabled class="form-check-inline" readonly id="" name="uso_publico" value="SI" [checked]="caract_anteproyecto[0].uso_publico == 'parte'" /> PARTE</span>
                                        </td>
                                        <td align="center" style="background: white; width: 6%">
                                            <span><input type="checkbox" disabled class="form-check-inline" readonly id="" name="uso_publico" value="SI" [checked]="caract_anteproyecto[0].uso_publico == 'no'" /> NO</span>
                                        </td>
                                    </tr>
                                </table>

                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td style="width:55%" class="fondoResaltado izquierda"><span>
                                             CUENTA CON ANTEPROYECTO APROBADO</span>
                                        </td>
                                        <td style="width: 5%" align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="anteproy_aprob" name="anteproy_aprob" value="SI" [checked]="caract_anteproyecto[0].anteproy_aprob == 'SI'" /><span>SI</span></td>
                                        <td style="width: 5%" align="center"><input type="checkbox" disabled class="form-check-inline" readonly id="anteproy_aprob" name="anteproy_aprob" value="NO" [checked]="caract_anteproyecto[0].anteproy_aprob == 'NO'" /><span>NO</span></td>
                                        <td style="width: 5%" class="fondoResaltado"><span>Res. N°</span></td>
                                        <td style="width: 12%"><span><input disabled class="form-control" readonly id="numero" name="numero" type="text" [(ngModel)]="caract_anteproyecto[0].numero"/></span></td>
                                        <td style="width: 6%" class="fondoResaltado"><span>Fecha</span></td>
                                        <td style="width: 12%"><span><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" [(ngModel)]="caract_anteproyecto[0].fecha"/></span></td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <br />
                            <br />
                            <br />
                        </div>
                        <div id='page3' class="contenedorFormulario print-wrap page3">
                            <div style="margin-bottom: 30px">
                                <span style="float: right; clear: right;">(S.P.E.- 5.1.4 / 5.1.6.)</span> <span>Formulario 2.3</span>
                                <span style="float: right; clear: right;">3/5</span>
                            </div>
                            <div>

                                <div class="tituloSeccion">
                                    <span class="help-block letraChica">6.1.- DESTINO (S) CONTEMPLADO(S)</span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="" name="residencial" value="SI" [checked]="destino[0].residencial" /></td>
                                        <td align="left">
                                            <span>RESIDENCIAL</span><br>
                                            <span>Art. 2.1.25.OGUC.</span>
                                        </td>
                                        <td>
                                            DESTINO ESPECIFICO
                                        </td>
                                        <td colspan="2">
                                            <input disabled class="form-control" readonly id="destino_resd" name="destino_resd" type="text" [(ngModel)]="destino[0].destino_resd" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white" rowspan="2">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="equipamiento" name="equipamiento" value="SI" [checked]="destino[0].equipamiento" />
                                        </td>
                                        <td align="left" rowspan="2">
                                            <span>Equipamiento</span><br>
                                            <span>Art. 2.1.33.OGUC.</span>
                                        </td>
                                        <td>
                                            Clase Art.2.1.33 OGUC.
                                        </td>
                                        <td>
                                            Actividad
                                        </td>
                                        <td>
                                            Escala Art.2.1.36. OGUC.
                                        </td>
                                    </tr>
                                    <tr>

                                        <td>
                                            <input disabled class="form-control" readonly id="clase_eq" name="clase_eq" type="text" [(ngModel)]="destino[0].clase_eq" />
                                        </td>

                                        <td>
                                            <input disabled class="form-control" readonly id="actividad_eq" name="actividad_eq" type="text" [(ngModel)]="destino[0].actividad_eq" />
                                        </td>

                                        <td>
                                            <input disabled class="form-control" readonly id="total1" name="escala_eq" type="text" [(ngModel)]="destino[0].escala_eq" />
                                        </td>

                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="actividad" name="actividad" value="SI" [checked]="destino[0].actividad" /></td>
                                        <td align="left">
                                            <span>ACTIVIDADES PRODUCTIVOS</span><br>
                                            <span>Art. 2.1.28.OGUC.</span>
                                        </td>
                                        <td>
                                            DESTINO ESPECIFICO
                                        </td>
                                        <td colspan="2"><input disabled class="form-control" readonly id="destino_act" name="destino_act" type="text" [(ngModel)]="destino[0].destino_act" /></td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="infraestructura" name="infraestructura" value="SI" [checked]="destino[0].infraestructura" /></td>
                                        <td align="left">
                                            <span>INFRAESTRUCTURA</span><br>
                                            <span>Art. 2.1.29.OGUC.</span>
                                        </td>
                                        <td>
                                            DESTINO ESPECIFICO
                                        </td>
                                        <td colspan="2"><input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="destino[0].destino_infr" /></td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white"><input type="checkbox" disabled class="form-check-inline" readonly id="otros" name="otros" value="SI" [checked]="destino[0].otros" /></td>
                                        <td align="left">
                                            <span>OTROS</span><br>
                                        </td>
                                        <td>
                                            (especificar)
                                        </td>
                                        <td colspan="2"><input disabled class="form-control" readonly id="esp_otros" name="esp_otros" type="text" [(ngModel)]="destino[0].esp_otros" /></td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span class="help-block letraChica">6.2.- SUPERFICIES</span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td>

                                        </td>
                                        <td>
                                            UTIL (m2)
                                        </td>
                                        <td>
                                            COM&Uacute;N (m2)
                                        </td>
                                        <td>
                                            TOTAL (m2)
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda">
                                            S. EDIFICADA BAJO TERRENO
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="util1" name="util1" type="text" [(ngModel)]="superficie_anteproyecto[0].util1" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="comun1" name="comun1" type="text" [(ngModel)]="superficie_anteproyecto[0].comun1" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="total1" name="total1" type="text" [(ngModel)]="superficie_anteproyecto[0].total1" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda">
                                            S. EDIFICADA SOBRE TERRENO
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_anteproyecto[0].util2" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_anteproyecto[0].comun2" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_anteproyecto[0].total2" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda">
                                            S. EDIFICACI&Oacute;N TOTAL
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_anteproyecto[0].util3" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_anteproyecto[0].comun3" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="destino_infr" name="destino_infr" type="text" [(ngModel)]="superficie_anteproyecto[0].total3" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado izquierda">
                                        <td>
                                            SUPERFICIE TOTAL TERRENO (m2)
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="totalt" name="totalt" type="text" [(ngModel)]="superficie_anteproyecto[0].totalt" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span class="help-block letraChica">6.3.-NORMAS URBANISTICAS APLICADAS</span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td>

                                        </td>
                                        <td>
                                            PERMITIDO
                                        </td>
                                        <td>
                                            PROYECTADO
                                        </td>
                                        <td>

                                        </td>
                                        <td>
                                            PERMITIDO
                                        </td>
                                        <td>
                                            PROYECTADO
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda">
                                            COEFICIENTE DE CONSTRUCTIBILIDAD
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="constr_perm" name="constr_perm" type="text" [(ngModel)]="normas_urbanisticas[0].constr_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="constr_proy" name="constr_proy" type="text" [(ngModel)]="normas_urbanisticas[0].constr_proy" />
                                        </td>
                                        <td class="fondoResaltado izquierda">
                                            COEF. DE OCUPACI&Oacute;N DE SUELO
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="suelo_perm" name="suelo_perm" type="text" [(ngModel)]="normas_urbanisticas[0].suelo_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="suelo_proy" name="suelo_proy" type="text" [(ngModel)]="normas_urbanisticas[0].suelo_proy" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda">
                                            COEF.DE OCUPACI&Oacute; PISOS<br> SUPERIORES
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="ocup_perm" name="ocup_perm" type="text" [(ngModel)]="normas_urbanisticas[0].ocup_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="ocup_proy" name="ocup_proy" type="text" [(ngModel)]="normas_urbanisticas[0].ocup_proy" />
                                        </td>
                                        <td class="fondoResaltado izquierda">
                                            DENSIDAD
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="densid_perm" name="densid_perm" type="text" [(ngModel)]="normas_urbanisticas[0].densid_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="densid_proy" name="densid_proy" type="text" [(ngModel)]="normas_urbanisticas[0].densid_proy" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda">
                                            ALTURA MAXIMA EN METRO o PISOS
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="alt_perm" name="alt_perm" type="text" [(ngModel)]="normas_urbanisticas[0].alt_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="alt_proy" name="alt_proy" type="text" [(ngModel)]="normas_urbanisticas[0].alt_proy" />
                                        </td>
                                        <td class="fondoResaltado izquierda">
                                            ADOSAMIENTO
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="adosam_perm" name="adosam_perm" type="text" [(ngModel)]="normas_urbanisticas[0].adosam_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="adosam_proy" name="adosam_proy" type="text" [(ngModel)]="normas_urbanisticas[0].adosam_proy" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda">
                                            RASANTE
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="rasant_perm" name="rasant_perm" type="text" [(ngModel)]="normas_urbanisticas[0].rasant_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="rasant_proy" name="rasant_proy" type="text" [(ngModel)]="normas_urbanisticas[0].rasant_proy" />
                                        </td>
                                        <td class="fondoResaltado izquierda">
                                            ANTEJARDIN
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="antej_perm" name="antej_perm" type="text" [(ngModel)]="normas_urbanisticas[0].antej_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="antej_proy" name="antej_proy" type="text" [(ngModel)]="normas_urbanisticas[0].antej_proy" />
                                        </td>
                                    </tr>
                                    <tr>
                                        <td class="fondoResaltado izquierda">
                                            DISTANCIAMIENTO
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="dist_perm" name="dist_perm" type="text" [(ngModel)]="normas_urbanisticas[0].dist_perm" />
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="dist_proy" name="dist_proy" type="text" [(ngModel)]="normas_urbanisticas[0].dist_proy" />
                                        </td>
                                    </tr>
                                </table>
                                <br />
                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td class="fondoResaltado izquierda">
                                            ESTACIONAMIENTOS REQUERIDOS
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="est_req" name="est_req" type="text" [(ngModel)]="normas_urbanisticas[0].est_req" />
                                        </td>
                                        <td class="fondoResaltado izquierda">
                                            ESTACIONAMIENTOS PROYECTO
                                        </td>
                                        <td>
                                            <input disabled class="form-control" readonly id="est_proy" name="est_proy" type="text" [(ngModel)]="normas_urbanisticas[0].est_proy" />
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <div>
                                <table class="tablaConBorde table form-group">
                                    <tr>
                                        <td colspan="4" class="fondoResaltado">CLASIFICACI&Oacute;N(ES) CONSTRUCCI&Oacute;N(ES) PREDOMINANTE(S)</td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td>
                                            CLASIFICACI&Oacute;N
                                        </td>
                                        <td>
                                            m2
                                        </td>
                                        <td>
                                            CLASIFICACI&Oacute;N
                                        </td>
                                        <td>
                                            m2
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado0">
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" [(ngModel)]="clasificacion[0].clasificacion" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" [(ngModel)]="clasificacion[0].metro" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[1]" />
                                            <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[1]" [(ngModel)]="clasificacion[1].clasificacion" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[1]" />
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[1]" [(ngModel)]="clasificacion[1].metro" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado0">
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[2]" />
                                            <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[2]" [(ngModel)]="clasificacion[2].clasificacion" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[2]" />
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[2]" [(ngModel)]="clasificacion[2].metro" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[3]" />
                                            <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[3]" [(ngModel)]="clasificacion[3].clasificacion" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[3]" />
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[3]" [(ngModel)]="clasificacion[3].metro" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado0">
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[4]" />
                                            <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[4]" [(ngModel)]="clasificacion[4].clasificacion" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[4]" />
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[4]" [(ngModel)]="clasificacion[4].metro" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[5]" />
                                            <input disabled class="form-control" readonly id="clasificacion" name="clasificacion" type="text" *ngIf="clasificacion[5]" [(ngModel)]="clasificacion[5].clasificacion" />
                                        </td>
                                        <td style="max-width: 281px; min-width: 281px;">
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="!clasificacion[5]" />
                                            <input disabled class="form-control" readonly id="metro" name="metro" type="text" *ngIf="clasificacion[5]" [(ngModel)]="clasificacion[5].metro" />
                                        </td>
                                    </tr>

                                </table>
                            </div>
                            <br>
                            <div>

                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado" style="width: 100%">
                                        <td colspan="8">DISPOSICIONES ESPECIALES A QUE SE ACOGER&Aacute; EL PROYECTO</td>
                                    </tr>
                                    <tr>
                                        <td align="left" style="background: white ; width: 20%">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion1" value="SI" [checked]="disposiciones_esp[0].disposicion1" /> D.F.L-Nº2 de 1959
                                        </td>
                                        <td align="left" style="background: white ; width: 25%">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion2" value="SI" [checked]="disposiciones_esp[0].disposicion2" /> Ley Nº 19.537 Copropiedad Inmobiliaria<br>(Posterior al
                                            otorgamiento del permiso)
                                        </td>
                                        <td align="left" style="background: white ; width: 25%">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion3" value="SI" [checked]="disposiciones_esp[0].disposicion3" /> Proyecci&oacute;n sombras <br> Art. 2.6.11. OGUC
                                        </td>
                                        <td align="left" style="background: white;  width: 30%">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion4" value="SI" [checked]="disposiciones_esp[0].disposicion4" /> Segunda Vivienda <br>Art.6.2.4. OGUC
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="left" style="background: white ;width: 45%" colspan="2">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion5" value="SI" [checked]="disposiciones_esp[0].disposicion5" /> Conjunto Arm&oacute;nico Art. 2.6.4. OGUC
                                        </td>
                                        <td align="left" style="background: white; width: 25%">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion6" value="SI" [checked]="disposiciones_esp[0].disposicion6" /> Beneficio Fusi&oacute;n Art. 63 LGUC
                                        </td>
                                        <td align="left" style="background: white ; width: 35%">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion7" value="SI" [checked]="disposiciones_esp[0].disposicion7" /> Conj. Viv. Econ. <br> Art. 6.1.8. OGUC
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="left" style="background: white ; height: 37px; width: 100%" colspan="4">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="disposicion8" value="SI" [checked]="disposiciones_esp[0].disposicion8" /> Otro (especificar)
                                        </td>
                                    </tr>
                                </table>
                                <br />
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td colspan="8">
                                            AUTORIZACIONES ESPECIALES LGUC
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td align="center" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="autorizacion1" value="SI" [checked]="autorizaciones[0].Art121" /> Art. 121
                                        </td>
                                        <td align="center" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="autorizacion2" value="SI" [checked]="autorizaciones[0].Art122" /> Art. 122
                                        </td>
                                        <td align="center" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="autorizacion3" value="SI" [checked]="autorizaciones[0].Art123" /> Art. 123
                                        </td>
                                        <td align="center" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="autorizacion4" value="SI" [checked]="autorizaciones[0].Art124" /> Art. 124
                                        </td>
                                        <td align="center" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="autorizacion5" value="SI" [checked]="autorizaciones[0].Ley19537" /> Art. 55
                                        </td>
                                        <td colspan="3" align="center" style="background: white; width: 40%">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="autorizacion6" value="SI" [checked]="autorizaciones[0].Otro" /> Otro (especificar)
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>
                                <div class="tituloSeccion">
                                    <span class="help-block letraChica">6.4.- NUMERO DE UNIDADES TOTALES POR DESTINO</span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td class="fondoResaltado izquierda">
                                            VIVIENDAS
                                        </td>
                                        <td align="left" style="background: white">
                                            <input disabled class="form-control" readonly id="vivienda" name="vivienda" type="text" [(ngModel)]="unidades[0].vivienda" />
                                        </td>
                                        <td class="fondoResaltado izquierda">
                                            OFICINAS
                                        </td>
                                        <td align="left" style="background: white">
                                            <input disabled class="form-control" readonly id="oficinas" name="oficinas" type="text" [(ngModel)]="unidades[0].oficinas" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td class="fondoResaltado izquierda">
                                            LOCALES COMERCIALES
                                        </td>
                                        <td align="left" style="background: white">
                                            <input disabled class="form-control" readonly id="locales" name="locales" type="text" [(ngModel)]="unidades[0].locales" />
                                        </td>
                                        <td class="fondoResaltado izquierda">
                                            ESTACIONAMIENTOS
                                        </td>
                                        <td align="left" style="background: white">
                                            <input disabled class="form-control" readonly id="estacionamientos" name="estacionamientos" type="text" [(ngModel)]="unidades[0].estacionamientos" />
                                        </td>
                                    </tr>
                                    <tr class="fondoResaltado">
                                        <td class="fondoResaltado izquierda">
                                            OTROS (ESPECIFICAR)
                                        </td>
                                        <td colspan="3" align="left" style="background: white">
                                            <input disabled class="form-control" readonly id="otros" name="otros" type="text" [(ngModel)]="unidades[0].otros" />
                                        </td>
                                    </tr>
                                </table>
                                <br />
                                <br />
                                <br />
                                <br />
                                <br />
                            </div>
                        </div>
                        <div id='page4' class="contenedorFormulario print-wrap page4">
                            <div style="margin-bottom: 30px">
                                <span style="float: right; clear: right;">(S.P.E.- 5.1.4 / 5.1.6.)</span> <span>Formulario 2.3</span>
                                <span style="float: right; clear: right;">4/5</span>
                            </div>



                            <div>
                                <div class="tituloSeccion">
                                    <span>7.- OTRAS SOLICITUDES</span>
                                    <span class="letraChica">  (QUE ACOMPAÑAN LA PRESENTE SOLICITUD)</span>
                                    <span class="help-block"></span>
                                </div>
                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td colspan="6" align="left">TRAMITACION CONJUNTA</td>
                                    </tr>
                                    <tr>
                                        <td align="center" style="background: white;  width: 3%">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="tramitacion_conj1" value="SI" [checked]="otras_solicitudes[0].tramitacion_conj1" />
                                        </td>
                                        <td style="text-align: left; width: 45%" colspan="2">
                                            DEMOLICI&Oacute;N
                                        </td>
                                        <td align="center" style="background: white; width: 3%">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="tramitacion_conj2" value="SI" [checked]="otras_solicitudes[0].tramitacion_conj2" />
                                        </td>
                                        <td style="text-align: left" colspan="2">
                                            INSTALACI&Oacute;N DE GRUAS Y SIMILARES
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="center" style="background: white; width: 3%">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="tramitacion_conj3" value="SI" [checked]="otras_solicitudes[0].tramitacion_conj3" />
                                        </td>
                                        <td style="text-align: left" colspan="2">
                                            INSTALACI&Oacute;N DE FAENAS
                                        </td>
                                        <td align="center" style="background: white; width: 3%">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="tramitacion_conj3" value="SI" [checked]="otras_solicitudes[0].tramitacion_conj3" />
                                        </td>
                                        <td style="text-align: left" colspan="2">
                                            EJECUCI&Oacute;N DE EXCAVACIONES , ENTIBACIONES Y SOCALZADOS
                                        </td>
                                    </tr>
                                </table>
                                <table class="tablaConBorde2 table form-group">
                                    <tr>
                                        <td align="center" style="background: white; width: 3%">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="tramitacion_conj4" value="SI" [checked]="otras_solicitudes[0].fusion" />
                                        </td>
                                        <td style="text-align: left; width: 30%">
                                            FUSI&Oacute;N
                                        </td>
                                        <td style="text-align: left; width: 33%">
                                            SOLICITUD Nº <input disabled class="form-control" readonly id="otros" name="otros" type="text" [(ngModel)]="otras_solicitudes[0].solicitud_fusion">
                                        </td>
                                        <td style="text-align: left">
                                            FECHA: <input disabled class="form-control" readonly id="otros" name="otros" type="text" [(ngModel)]="otras_solicitudes[0].fecha_fusion">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="center" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="fusion" value="SI" [checked]="otras_solicitudes[0].cambio" />
                                        </td>
                                        <td style="text-align: left ; width: 30%">
                                            CAMBIO DE DESTINO
                                        </td>
                                        <td style="text-align: left ; width: 33%">
                                            <span disabled>SOLICITUD Nº </span><input disabled class="form-control" readonly id="otros" name="otros" type="text" [(ngModel)]="otras_solicitudes[0].solicitud_cambio">
                                        </td>
                                        <td style="text-align: left">
                                            <span disable>FECHA: </span><input disabled class="form-control" readonly id="otros" name="otros" type="text" [(ngModel)]="otras_solicitudes[0].fecha_cambio">
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="center" style="background: white">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="cambio" value="SI" [checked]="otras_solicitudes[0].cambio" />
                                        </td>
                                        <td style="text-align: left">
                                            OTRAS
                                        </td>
                                        <td style="text-align: left" colspan="4">

                                        </td>
                                    </tr>
                                </table>
                                <table class="tablaConBorde2 table form-group">
                                    <tr class="fondoResaltado">
                                        <td class="fondoResaltado" align="left" colspan="6">
                                            TRAMITACI&Oacute;N SIMULT&Aacute;NEA
                                        </td>
                                    </tr>
                                    <tr>
                                        <td align="center" style="background: white;  width: 3%">
                                            <input type="checkbox" disabled class="form-check-inline" readonly id="" name="cambio" value="SI" [checked]="otras_solicitudes[0].cambio" />
                                        </td>
                                        <td style="text-align: left ; width: 30%">
                                            LOTEO
                                        </td>
                                        <td class="fondoResaltado" style="text-align: left ;width: 15%">
                                            SOLICITUD Nº
                                        </td>
                                        <td style="text-align: left ; width: 18%">
                                            <input disabled class="form-control" readonly id="otros" name="otros" type="text" [(ngModel)]="otras_solicitudes[0].solicitud_loteo">
                                        </td>
                                        <td class="fondoResaltado" style="text-align: left ; width: 20%">
                                            FECHA
                                        </td>
                                        <td style="text-align: left ; width: 15%">
                                            <input disabled class="form-control" readonly id="otros" name="otros" type="text" [(ngModel)]="otras_solicitudes[0].fecha_loteo">
                                        </td>
                                    </tr>
                                </table>
                            </div>
                            <div>

                                <div class="col-md-12" style="padding-left: 0px">
                                    <div class="col-md-12 tituloSeccion" style="padding-left: 0px">
                                        <span>8.- PERMISOS Y RECEPCIONES ANTERIORES</span>
                                        <span class="help-block"></span>
                                    </div>
                                    <table class="tablaConBorde table form-group">
                                        <tr class="fondoResaltado" style="height: 30px;">
                                            <td style="width: 25%">PERMISO PRIMITIVO</td>
                                            <td style="width: 15%">N°</td>
                                            <td style="width: 15%">FECHA</td>
                                            <td style="width: 15%">SUPERFICIE M2</td>
                                            <td style="width: 15%">RECEPCION N°</td>
                                            <td style="width: 15%">FECHA</td>
                                        </tr>
                                        <tr *ngFor="let permiso of perm">
                                            <td><input disabled class="form-control" readonly id="permiso_prim" name="permiso_prim" type="text" [(ngModel)]="permiso.permiso" /></td>
                                            <td><input disabled class="form-control" readonly id="permiso_num" name="permiso_num" type="text" [(ngModel)]="permiso.numero" /></td>
                                            <td><input disabled class="form-control" readonly id="permiso_fecha" name="permiso_fecha" type="text" [(ngModel)]="permiso.fecha" /></td>
                                            <td><input disabled class="form-control" readonly id="superficie" name="superficie" type="text" [(ngModel)]="permiso.superficie" /></td>
                                            <td><input disabled class="form-control" readonly id="recepcion" name="recepcion" type="text" [(ngModel)]="permiso.recepcion" /></td>
                                            <td><input disabled class="form-control" readonly id="fecha_recep" name="fecha_recep" type="text" [(ngModel)]="permiso.fecha_recep" /></td>
                                        </tr>
                                        <tr class="fondoResaltado" style="height: 30px;">
                                            <td style="width: 25%">MODIFICACIONES Y AMPLIACIONES</td>
                                            <td style="width: 15%">N°</td>
                                            <td style="width: 15%">FECHA</td>
                                            <td style="width: 15%">SUPERFICIE M2</td>
                                            <td style="width: 15%">RECEPCION N°</td>
                                            <td style="width: 15%">FECHA</td>
                                        </tr>
                                        <tr *ngFor="let recepcion of recep">
                                            <td><input disabled class="form-control" readonly id="modif_prim1" name="modif_prim1" type="text" [(ngModel)]="recepcion.permiso" /></td>
                                            <td><input disabled class="form-control" readonly id="modif_num1" name="modif_num1" type="text" [(ngModel)]="recepcion.numero" /></td>
                                            <td><input disabled class="form-control" readonly id="modif_fecha1" name="modif_fecha1" type="text" [(ngModel)]="recepcion.fecha" /></td>
                                            <td><input disabled class="form-control" readonly id="modif_sup1" name="modif_sup1" type="text" [(ngModel)]="recepcion.superficie" /></td>
                                            <td><input disabled class="form-control" readonly id="mod_recep1" name="mod_recep1" type="text" [(ngModel)]="recepcion.recepcion" /></td>
                                            <td><input disabled class="form-control" readonly id="mod_fecha_recep1" name="mod_fecha_recep1" type="text" [(ngModel)]="recepcion.fecha_recep" /></td>
                                        </tr>

                                    </table>

                                </div>
                            </div>

                            <br />
                            <div>
                                <div class="tituloSeccion">
                                    <span>9.- ANTECEDENTES QUE SE ADJUNTAN</span>
                                    <br>
                                    <span>9.1- PARA PERMISO DE EDIFICACIÓN, OBRA NUEVA, AMPLIACION MAYOR A 100 M2</span>
                                    <span class="help-block"></span>
                                    <span class="letraChica">(ART. 1.2.1/1.4.2/5.1.6. O.G.U.C)</span>
                                </div>

                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 5%">DOM</td>
                                        <td colspan="2" style="width:44% " align="center">Documentos</td>
                                        <td style="width: 5%">DOM</td>
                                        <td colspan="2" align="center"> Planos</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].obra ||tipo_permiso[0].ampliacion"/></td>
                                        <td><span>Listado de documentos y Planos numerados</span></td>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].obra ||tipo_permiso[0].ampliacion"/></td>
                                        <td><span>Ubicaci&oacute;n del predio</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].obra ||tipo_permiso[0].ampliacion"/></td>
                                        <td><span>Fotocopia del certificado de informaciones previas vigentes</span></td>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].obra ||tipo_permiso[0].ampliacion"/></td>
                                        <td><span>Emplazamiento</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].obra ||tipo_permiso[0].ampliacion"/></td>
                                        <td><span>Formulario &uacute;nico de estad&iacute;a de edificaci&oacute;n</span></td>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].obra ||tipo_permiso[0].ampliacion"/></td>
                                        <td><span>Planta de todos los pisos</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].obra && !tipo_permiso[0].ampliacion" /></td>
                                        <td><span>Informe del Revisor Independiente, cuando correponda</span></td>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].obra ||tipo_permiso[0].ampliacion"/></td>
                                        <td><span>Cortes y Elevaciones</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].obra && !tipo_permiso[0].ampliacion" /></td>
                                        <td><span>Informe favorable del Revisor de Proyecto de C&aacute;lculo estructural (cuando corresponda)</span></td>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].obra ||tipo_permiso[0].ampliacion"/></td>
                                        <td><span>Plano de cierro, cuando el proyecto lo consulte</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].obra && !tipo_permiso[0].ampliacion" /></td>
                                        <td><span>Certificado de inscripci&oacute;n Revisor Proyecto de Calculo (cuando corresponda)</span></td>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].obra ||tipo_permiso[0].ampliacion"/></td>
                                        <td><span>Cuadro de superficies</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].obra ||tipo_permiso[0].ampliacion"/></td>
                                        <td><span>Especificaciones T&eacute;cnicas</span></td>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].obra && !tipo_permiso[0].ampliacion" /></td>
                                        <td><span>Plano comparativo de sombras, (cuando corresponda)</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].obra && !tipo_permiso[0].ampliacion" /></td>
                                        <td><span>Fotocopia Resoluci&oacute;n que aprueba anteproyecto, si corresponde</span></td>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].obra && !tipo_permiso[0].ampliacion" /></td>
                                        <td><span>Proyecto de c&acute;lculo estructural (cuando corresponda)</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].obra ||tipo_permiso[0].ampliacion"/></td>
                                        <td><span>Patentes de Profesionales Competentes.</span></td>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].obra && !tipo_permiso[0].ampliacion" /></td>
                                        <td><span>Planos de estructura, acompañados de los c&acute;lculos de estabilidad de la construcci&oacute;n cuando corresponda</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].obra && !tipo_permiso[0].ampliacion" /></td>
                                        <td><span>Certificado de factibilidad de daci&oacute;n de servicios de agua potable y alcantarillado o proyecto de agua potable y alcantarillado, aprobado por la autoriadad respectiva. (en &aacute;reas no concesionadas)</span></td>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].obra && !tipo_permiso[0].ampliacion" /></td>
                                        <td><span>Otros (especificar)</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].obra && !tipo_permiso[0].ampliacion" /></td>
                                        <td><span>Cuadro de superficies (salvo que se incluya en los planos)</span></td>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].obra && !tipo_permiso[0].ampliacion" /></td>
                                        <td><span>Otros (especificar)</span></td>
                                    </tr>

                                </table>


                            </div>
                            <br />
                            <div>
                                <div class="tituloSeccion">
                                    <span>9.2- PARA PERMISOS DE ALTERACION, REPARACION, RECONSTRUCCION</span>
                                    <span class="help-block"></span>
                                    <span class="letraChica">(ART. 5.1.4/1.2.1/1.4.2. O.G.U.C)</span>
                                </div>

                                <table class="tablaConBorde table form-group">
                                    <tr class="fondoResaltado">
                                        <td style="width: 5%">DOM</td>
                                        <td colspan="2" style="width:44% ">DOCUMENTOS</td>
                                        <td style="width: 5%">DOM</td>
                                        <td colspan="2">PLANOS</td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].alteracion || tipo_permiso[0].reparacion || tipo_permiso.reconstruccion" /></td>
                                        <td><span>Especificaciones T&eacute;cnicas de aquellas partes del edificio que sufran cambios con respecto a los antecedentes primitivamente aprobados</span></td>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].alteracion || tipo_permiso[0].reparacion || tipo_permiso.reconstruccion"></td>
                                        <td><span>Planos de aquellas partes del edificio que sufran cambios con respecto a los antecedentes primitivamente aprobados</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].alteracion || tipo_permiso[0].reparacion || tipo_permiso.reconstruccion"/></td>
                                        <td><span>Presupuesto informativo de las obras correspondientes</span></td>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].alteracion && !tipo_permiso[0].reparacion && !tipo_permiso.reconstruccion" /></td>
                                        <td><span>Planos de estructura, cuando corresponda</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].alteracion && !tipo_permiso[0].reparacion && !tipo_permiso.reconstruccion" /></td>
                                        <td><span>Memoria de c&aacute;lculo estructural, cuando corresponda</span></td>
                                        <td rowspan="7" colspan="3"><span></span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].alteracion && !tipo_permiso[0].reparacion && !tipo_permiso.reconstruccion" /></td>
                                        <td><span>Informe del Revisor independiente, cuando corresponda</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].alteracion || tipo_permiso[0].reparacion || tipo_permiso.reconstruccion"/></td>
                                        <td><span>Certificado de Inscripci&oacute;n del Revisor Independiente</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].alteracion && !tipo_permiso[0].reparacion && !tipo_permiso.reconstruccion" /></td>
                                        <td><span>Informe del Revisor del Proyecto de C&aacute;lculo Estructural cuando corresponda</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" [disabled]="!tipo_permiso[0].alteracion && !tipo_permiso[0].reparacion && !tipo_permiso.reconstruccion" /></td>
                                        <td><span>Certificado de Inscripci&oacute;n del Revisor del Proyecto de C&aacute;lculo Estructural, cuando corresponda</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].alteracion || tipo_permiso[0].reparacion || tipo_permiso.reconstruccion"/></td>
                                        <td><span>Fotocopia de la patente al d&iacute;a de los Profesionales Competentes</span></td>
                                    </tr>
                                    <tr>
                                        <td style="width: 5%"></td>
                                        <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" disabled [checked]="tipo_permiso[0].alteracion || tipo_permiso[0].reparacion || tipo_permiso.reconstruccion"/></td>
                                        <td><span>Cuadro de Superficies Modificadas (salvo que se incluya en los planos)</span></td>
                                    </tr>

                                </table>


                            </div>
                            <div>
                                <span class="letraChica">DEBER&Aacute; ACOMPAÑARSE AL MOMENTO DE LA SOLICITUD, UNA COPIA DE LOS DOCUMENTOS Y PLANOS<br> UNS VEZ APROBADA LA SOLICITUD DEBER&Aacute; ACOMPAÑARSE DEOS COPIAS DE LOS PLANOS, CUADRO DE SUPERFICIE Y ESPECIFICACIONES T&Eacute;CNICAS</span>
                            </div>
                        </div>
                        <br>
                        <br>
                        <div id='page5' class="contenedorFormulario print-wrap page5">
                            <div>
                                <div><span style="float: right; clear: right;">(S.P.E.- 5.1.4 / 5.1.6.)</span>
                                    <span style="float: right; clear: right;">5/5</span>
                                </div>

                                <div>
                                    <div class="tituloSeccion">
                                        <span>9.3- OTROS ANTECEDENTES, </span><span class="letraChica">cuando corresponda</span>
                                    </div>

                                    <table class="tablaConBorde table form-group">
                                        <tr class="fondoResaltado">
                                            <td style="width: 5%">DOM</td>
                                            <td colspan="2" style="width:95% ">ESTUDIOS, RESOLUCIONES o INFORMES ADICIONALES QUE SE ACOMPAÑAN (SI PROCEDE)</td>
                                        </tr>
                                        <tr>
                                            <td style="width: 5%"></td>
                                            <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                            <td><span>Carga combustible. Art.4.3.4. O.G.U.C.</span></td>
                                        </tr>
                                        <tr>
                                            <td style="width: 5%"></td>
                                            <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                            <td><span>Estudio de Seguridad. Art.4.2.13., 4.2.14., 4.2.15., 4.3.1., 4.3.2., 4.3.6. O.G.U.C</span></td>
                                        </tr>
                                        <tr>
                                            <td style="width: 5%"></td>
                                            <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                            <td><span>Mec&aacute;nica de Suelo. Art 1.2.13. O.G.U.C</span></td>
                                        </tr>
                                        <tr>
                                            <td style="width: 5%"></td>
                                            <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                            <td><span>Estudio de Evacuaci&oacute;n</span></td>
                                        </tr>
                                        <tr>
                                            <td style="width: 5%"></td>
                                            <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                            <td><span>Informe calidad del subsuelo Art. 5.1.15. O.G.U.C</span></td>
                                        </tr>
                                        <tr>
                                            <td style="width: 5%"></td>
                                            <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                            <td><span>Impacto sobre Sistema de Transporte Urbano (EISTU) Art. 2.4.3, 4.5.4, 4.8.3, 4.13.4 O.G.U.C</span></td>
                                        </tr>
                                        <tr>
                                            <td style="width: 5%"></td>
                                            <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                            <td><span>Resoluci&oacute;n Consejo de Monumentos Nacionales</span></td>
                                        </tr>
                                        <tr>
                                            <td style="width: 5%"></td>
                                            <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                            <td><span>Informe SEREMI, Art. 60 L.G.U.C.</span></td>
                                        </tr>
                                        <tr>
                                            <td style="width: 5%"></td>
                                            <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                            <td><span>Estudio de ascensores, si corresponde. Art. 4.1.11 O.G.U.C</span></td>
                                        </tr>
                                        <tr>
                                            <td style="width: 5%"></td>
                                            <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                            <td><span>Estudio de riesgo. Art. 2.1.17. O.G.U.C</span></td>
                                        </tr>
                                        <tr>
                                            <td style="width: 5%"></td>
                                            <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                            <td><span>Construcciones en el &aacute;rea rural (Informe favoorable SEREMI-MINVU y SAG). Art. 55 L.G.U.C</span></td>
                                        </tr>
                                        <tr>
                                            <td style="width: 5%"></td>
                                            <td align="center" style="width: 3%"><input type="checkbox" class="form-check-inline" id="documentos" name="documentos" /></td>
                                            <td><span>Otros (especificar)</span></td>
                                        </tr>

                                    </table>

                                </div>
                                <div>
                                    <div class="tituloSeccion">
                                        <span>10.- MONTO A CONSIGNAR AL INGRESAR </span><span class="letraChica"> (A LLENAR POR LA D.O.M)</span>
                                        <span class="help-block"></span>
                                    </div>

                                    <table class="tablaConBorde table form-group">
                                        <tr class="fondoResaltado">
                                            <td colspan="4" rowspan="4">
                                                CLASIFICACI&Oacute;N (ES) DE LA CONSTRUCCI&Oacute;N
                                            </td>
                                        </tr>
                                        <tr class="fondoResaltado">
                                            <td>

                                                Clasificaci&oacute;n
                                            </td>
                                            <td>
                                                m2
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                            <td>
                                                <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="4">
                                                PRESUPUESTO
                                            </td>
                                            <td colspan="2">
                                                <input disabled value="$" class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                SUBTOTAL DERECHOS MUNICIPALES
                                            </td>
                                            <td class="fondoResaltado" align="right" style="width: 3%">
                                                %
                                            </td>
                                            <td colspan="2">
                                                <input disabled value="$" class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                DESCUENTO 30% CON INFORME DE REVISOR INDEPENDIENTE (*)
                                            </td>
                                            <td class="fondoResaltado" align="right">
                                                (-)
                                            </td>
                                            <td colspan="2">
                                                <input disabled value="$" class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                TOTAL DERECHOS MUNICIPALES
                                            </td>
                                            <td class="fondoResaltado" align="right">
                                                %
                                            </td>
                                            <td colspan="2">
                                                <input value="$" disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                CONSIGNADO AL INGRESO ANTEPROYECTO
                                            </td>
                                            <td>
                                                G.I.M. Nº
                                            </td>
                                            <td>
                                                FECHA:
                                            </td>
                                            <td class="fondoResaltado" align="right">
                                                %
                                            </td>
                                            <td colspan="2">
                                                <input value="$" disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td style="width: 30%">
                                                CONSIGNADO CON ANTEPROYECTO
                                            </td>
                                            <td style="width: 15%">
                                                G.I.M. Nº
                                            </td>
                                            <td style="width: 15%">
                                                FECHA:
                                            </td>
                                            <td class="fondoResaltado" align="right">
                                                %
                                            </td>
                                            <td colspan="2">
                                                <input value="$" disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td colspan="3">
                                                MONTO A CONSIGNAR AL INGRESO DE LA PRESENTE SOLICITUD
                                            </td>
                                            <td class="fondoResaltado" align="right">
                                                %
                                            </td>
                                            <td colspan="2">
                                                <input value="$" disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                    </table>
                                    <table class="tablaConBorde2 table form-group">
                                        <tr>
                                            <td style="width: 58%">
                                                GIRO INGRESO MUNICIPAL
                                            </td>
                                            <td class="fondoResaltado" align="right" style="width: 3%">
                                                Nº
                                            </td>
                                            <td style="width: 14%">
                                                <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                            <td class="fondoResaltado" style="width: 7%">
                                                Fecha
                                            </td>
                                            <td style="width: 15%">
                                                <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                GIRO INGRESO MUNICIPAL
                                            </td>
                                            <td class="fondoResaltado" align="right">
                                                Nº
                                            </td>
                                            <td>
                                                <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                            <td class="fondoResaltado">
                                                Fecha
                                            </td>
                                            <td>
                                                <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                        <tr>
                                            <td>
                                                CONVENIO DE PAGO
                                            </td>
                                            <td class="fondoResaltado" align="right">
                                                Nº
                                            </td>
                                            <td>
                                                <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                            <td class="fondoResaltado">
                                                Fecha
                                            </td>
                                            <td>
                                                <input disabled class="form-control" readonly id="total3" name="total3" type="text" />
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <br>
                                <div>
                                    <table class="tablaConBorde table form-group">
                                        <tr>
                                            <td>
                                                <strong>NOTAS: Situaciones especiales</strong>
                                                <br>
                                                <br>
                                                <br>
                                                <br>
                                                <br>
                                                <br>
                                            </td>
                                        </tr>
                                    </table>
                                </div>
                                <br />
                                <br />
                                <br />
                                <br />
                                <hr>
                                <div class="col-md-3"></div>
                                <div style="padding-left: 72px" class="col-md-6">
                                    <h1><strong>COMPROBANTE DE INGRESO</strong></h1>

                                </div>
                                <div class="col-md-3">
                                    <span style="float: right; clear: right;">(S.P.E.- 5.1.4 / 5.1.6.)</span>
                                </div>
                                <div class="col-md-12 tituloSeccion" align="center">
                                    <span>SOLICITUD DE PERMISO DE EDIFICACI&Oacute;N</span>
                                    <span class="help-block"></span>
                                </div>
                            </div>
                            <br>
                            <br />
                            <br />
                            <div>
                                <table class="tablaConBorde izquierda">
                                    <tr>
                                        <td class="fondoResaltado">MONTO CONSIGNADO AL INGRESO</td>
                                        <td><input disabled class="form-control" readonly id="monto" name="monto" type="text" value="$" /></td>
                                        <td class="fondoResaltado">GIM N°</td>
                                        <td><input disabled class="form-control" readonly id="gim" name="gim" type="text" /></td>
                                        <td class="fondoResaltado">FECHA</td>
                                        <td><input disabled class="form-control" readonly id="fecha" name="fecha" type="text" /></td>
                                    </tr>
                                </table>
                            </div>
                            <br />
                            <div class="row">
                                <div class="col-md-3">
                                    <table class="tablaConBordeExterno">
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr>
                                            <td>&nbsp;</td>
                                        </tr>
                                        <tr align="center">
                                            <td>FIRMA FUNCIONARIO.</td>
                                        </tr>
                                        <tr align="center">
                                            <td> Y TIMBRE D.O.M.</td>
                                        </tr>

                                    </table>

                                </div>
                                <br />
                                <div class="col-md-1"></div>
                                <div class="col-md-4">
                                    <h2 class="infObligatorios">
                                        <strong> DIRECCION DE OBRAS - MUNICIPALIDAD DE {{nombreMuni | uppercase}}</strong></h2>
                                    <h2 class="infObligatorios"> {{region}} </h2>
                                </div>
                                <div class="col-md-4">
                                    <table style="float: right; clear: right; width: 64%;" class="tablaConBorde table">
                                        <tbody>
                                            <tr>
                                                <td align="center" class="fondoResaltado">
                                                    N&Uacute;MERO SOLICITUD
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center">
                                                    <input class="form-control" type="text" id="num_sol" value="" name="num_sol" disabled />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td align="center" class="fondoResaltado" style="width: 20%">
                                                    Fecha de Ingreso
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>
                                                    <input class="form-control" type="text" id="fecha_ingreso" value="" name="fecha_ingreso" disabled />
                                                </td>
                                            </tr>
                                        </tbody>

                                    </table>
                                </div>
                            </div>
                            <br />
                            <div>
                                <table class="tablaConBorde">
                                    <tr class="fondoResaltado">
                                        <td style="width: 80%">CALLE O CAMINO</td>
                                        <td>N&Uacute;MERO</td>
                                    </tr>
                                    <tr>
                                        <td><input class="form-control" type="text" id="calle" name="calle" disabled [(ngModel)]="propiedad[0].calle" /></td>
                                        <td><input class="form-control" type="text" id="numero" name="numero" disabled [(ngModel)]="propiedad[0].calle_num" /></td>
                                    </tr>
                                </table>
                            </div>
                            <hr />
                            <br />
                            <br />
                            <br />
                            <br />

                            <br />
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-12" align="left">
                <button mat-raised-button color="primary" id="pdf-download-link" title="Descargar Formulario 2.3" (click)="captureScreen()">Descargar Formulario 2.3</button>
            </div>
        </fieldset>
    </div>
</div>